<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o2T0lZ/tc-custom/9780226676173.jpg?1738761058637" alt="This image is the cover for the book How to Grow a Human"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Grow a Human
      </h1>
      <p class="bookDescription body article font2">
        <b>The award-winning science writer shares “a winding romp through advances in cell biology [that] pushes readers to ponder the boundaries of life” (<i>Science</i>).</b><br/><br/>In the summer of 2017, scientists removed a tiny piece of flesh from Philip Ball’s arm and turned it into a rudimentary “mini-brain.” The skin cells, removed from his body, did not die but were instead transformed into nerve cells that independently arranged themselves into a dense network and communicated with each other, exchanging the raw signals of thought. This was life—but whose? That disconcerting question is the focus of Philip Ball’s <i>How to Grow a Human</i>.<br/><br/>In this mind-bending tour of cutting-edge cell biology, Ball shows how recent innovations could lead to tailor-made replacement organs; new medical advances for repairing damage and assisting conception; and new ways of “growing a human.” Such methods would also create new options for gene editing, with all the attendant moral dilemmas. <br/><br/>Ball argues that these advances can never be “just about the science,” because they are already laden with a host of social narratives, preconceptions, and prejudices. But beyond even that, these developments raise provocative questions about identity and self, birth and death, and force us to ask how mutable the human body really is—and what forms it might take in years to come.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip Ball
      </h2>
      
      <p class="authorDescription body article"><B>Philip Ball</B> is a writer, author, and broadcaster, and he was formerly an editor at <I>Nature</I>. His writing on scientific subjects has appeared in places ranging from <I>New Scientist</I> to the <I>New York Times</I>. He is the author of several books, including, most recently, <I>Beyond Weird</I>, also published by the University of Chicago Press. He lives in London.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22997e12